import React from 'react';

import {useThreadDraft} from 'features/drafts';

import Editor from '../editor';
import {useVirtualizedContext} from 'components/threading/virtualized_thread_viewer/virtualized_context';

const CreateCommentMemo = React.memo(Editor);

export function WithCommentDraft(props: {rootId: string}) {
    const draft = useThreadDraft(props.rootId);
    const {scrollToBottom} = useVirtualizedContext();

    return (
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        <CreateCommentMemo
            key={props.rootId}
            draft={draft}
            onReplyHandle={scrollToBottom}
            dataTestId={'ThreadEditor'}
            {...props}
        />
    );
}
